import React from "react";
import PropTypes from "prop-types";

import { SFCircleIcon } from "../../../icons";
import { SFStack } from "../../../grid";
import getStyled from "../../../../hooks/getStyled";

const { styled } = getStyled();

const SFStackWrapper = styled(SFStack)(() => ({
  height: "100%",
}));

const SFStatusRenderer = (props) => {
  return (
    <SFStackWrapper alignItems="center" justifyContent={"center"}>
      <SFCircleIcon
        color={props.value === true ? "green400" : "grey300"}
        size="xsmall"
      />
    </SFStackWrapper>
  );
};

SFStatusRenderer.propTypes = {
  value: PropTypes.bool,
};

export default SFStatusRenderer;
